// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component_FkGou","content":"index_content_2yY_v"};